import API from '@/services/API'
import store from '@/store/store'
import AuthenticationService from '@/services/AuthenticationService'

export default {
	// School Structure
	async addSchool (school) {
		try {
			await API.post('school', school, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return
		} catch (err) {
			console.log(err)
		}
	},
	async deleteSchool (schoolId) {
		try {
			await API.delete(`school/${schoolId}`, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return
		} catch (err) {
			if (err.response.status === 401) AuthenticationService.logout()
		}
	},
	async addProgram (program) {
		try {
			await API.post('program', program, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return
		} catch (err) {
			console.log(err)
		}
	},
	async deleteProgram (programId) {
		try {
			await API.delete(`program/${programId}`, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return
		} catch (err) {
			if (err.response.status === 401) AuthenticationService.logout()
		}
	},
	async addCourse (course) {
		try {
			await API.post('course', course, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return
		} catch (err) {
			console.log(err)
		}
	},
	async deleteCourse (courseId) {
		try {
			await API.delete(`course/${courseId}`, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return
		} catch (err) {
			if (err.response.status === 401) AuthenticationService.logout()
		}
	},
	async editCourse (course) {
		try {
			await API.put('course', course, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return
		} catch (err) {
			if (err.response.status === 401) AuthenticationService.logout()
		}
	},
	async recommendPlanning (recommended, planningId) {
		try {
			if (recommended) {
				await API.post(`planning/recommend/${planningId}`, {}, {
					headers: {
						Authorization: `Bearer ${store.state.authentication.token}`
					}
				})
			} else {
				await API.delete(`planning/recommend/${planningId}`, {
					headers: {
						Authorization: `Bearer ${store.state.authentication.token}`
					}
				})
			}
			return
		} catch (err) {
			console.log(err)
		}
	}
}
